import { render, staticRenderFns } from "./price-edit.vue?vue&type=template&id=9882a8fc&scoped=true&"
import script from "./price-edit.vue?vue&type=script&lang=js&"
export * from "./price-edit.vue?vue&type=script&lang=js&"
import style0 from "./price-edit.vue?vue&type=style&index=0&id=9882a8fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9882a8fc",
  null
  
)

export default component.exports